// Empêche un open redirect: n'autorise que les chemins internes relatifs (ex: "/dsn-list/123"),
// jamais une URL absolue ni un chemin protocol-relative (ex: "//evil.com").
export const isSafeInternalPath = (path: unknown): path is string => {
  if (typeof path !== 'string' || path.length === 0) return false;
  if (!path.startsWith('/') || path.startsWith('//')) return false;
  if (path.includes('://')) return false;
  return true;
};
